import React from 'react';
import { useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import styles from './hero.module.css';

// const ASImage = () => {
//   const { file } = useStaticQuery(graphql`
//     query {
//       file(relativePath: { eq: "asx_logo.png" }) {
//         childImageSharp {
//           fixed(height: 60) {
//             ...GatsbyImageSharpFixed
//           }
//         }
//       }
//     }
//   `)
//   return (
//     <Img
//       fixed={file.childImageSharp.fixed}
//       alt="AS Consulting logo"
//       objectFit="contain"
//     />
//   )
// }
export default () => {
	const { file } = useStaticQuery(graphql`
		query {
			file(relativePath: { eq: "header_blog.png" }) {
				childImageSharp {
					fluid(
						maxWidth: 1180
						maxHeight: 480 # resizingBehavior: PAD # background: "rgb:000000"
					) {
						...GatsbyImageSharpFluid_tracedSVG
					}
				}
			}
		}
	`);
	return (
		<div className={styles.hero}>
			{/* <Img
        className={styles.heroImage}
        alt="Background image"
        fluid={file.childImageSharp.fluid}
      /> */}
			<div className={styles.heroDetails}>
				{/* <img alt="Logo AS Xpert" src={require('../images/asx_logo.png')} styles={{ height: 90 }} /> */}
				<h3 className={styles.heroHeadline}>Blog</h3>
				{/* <p className={styles.heroTitle}>{data.title}</p> */}
				{/* <p>{data.shortBio.shortBio}</p> */}
			</div>
		</div>
	);
};
